import { configureStore } from '@reduxjs/toolkit'
import authSlice from './authSlice'
import botSlice from './botSlice'
import menuSlice from './menuSlice'
import conversationSlice from './conversationSlice'
import appSlice from './appSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    bot: botSlice,
    menu: menuSlice,
    conversation: conversationSlice,
    app: appSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch



